import { alpha, css } from '@mui/material/styles';
export const cardComponentOverrides = {
    MuiCard: {
        defaultProps: {
            raised: false,
            elevation: 0
        },
        variants: [
            {
                props: {},
                style: ({ theme }) => css `
                    box-shadow: ${theme.tokens.FuelShadowBase};
                `
            },
            {
                props: {
                    variant: 'elevated'
                },
                style: ({ theme }) => css `
                    box-shadow: ${theme.tokens.FuelShadowBase};
                `
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: ({ theme }) => css `
                    box-shadow: none;
                    border: solid 1px ${theme.tokens.FuelColorBorderBase};
                `
            }
        ],
        styleOverrides: {
            root: ({ theme }) => css `
                overflow: unset;
                border-radius: ${theme.tokens.FuelBorderRadiusLg};

                &[data-fuel-border-radius='large'], &[data-fuel-border-radius='lg'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusLg};
                }

                &[data-fuel-border-radius='small'], &[data-fuel-border-radius='sm'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusSm};
                }

                &[data-fuel-border-radius='medium'], &[data-fuel-border-radius='md'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusMd};
                }

                &[data-fuel-border-radius='xl'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusXl};
                }

                &[data-fuel-border-radius='2xl'] {
                    border-radius: ${theme.tokens.FuelBorderRadius2xl};
                }

                &[data-fuel-border-radius='full'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusFull};
                }

                &[data-fuel-border-radius='none'] {
                    border-radius: ${theme.tokens.FuelBorderRadiusNone};
                }

                /* --------- Tabs --------- */
                /* --- Standard --- */
                &[role='tabpanel'] {
                    margin-top: ${theme.tokens.FuelSpacing3};
                }

                /* --- Contained --- */
                &[data-fuel-tabs-contained=true] {
                    &[role='tabpanel'] {
                        margin-top: 0;
                    }

                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    box-shadow: none;
                    border: solid 1px ${theme.tokens.FuelColorBorderBase};
                    border-top: 0;

                    & .MuiTabs-root {
                        box-shadow: none;
                    }
                }

                /* --- In a Card --- */
                & .MuiTabs-root .MuiTab-root {
                    &:first-of-type:active {
                        border-top-left-radius: ${theme.tokens.FuelSpacing2};
                    }
                }

                /* --------- Accordion --------- */
                &:has(.MuiAccordion-root) {
                    border: unset;
                    background-color: unset;

                    &.MuiPaper-outlined {
                        outline: ${theme.tokens.FuelColorBorderBase} solid 1px;
                    }
                }

                &:has(.MuiAccordion-root[data-fuel-spaced=true]) {
                    border: unset;
                    outline: unset;
                    box-shadow: none;

                    &.MuiPaper-outlined .MuiAccordion-root {
                        outline: ${theme.tokens.FuelColorBorderBase} solid 1px;
                    }

                    &.MuiPaper-elevated .MuiAccordion-root {
                        box-shadow: ${theme.tokens.FuelShadowBase};
                    }
                }

                &:has(.MuiAccordion-root.Mui-disabled) {
                    background-color: ${alpha(theme.tokens.FuelColorWhite, 0.4)};

                    &.MuiPaper-outlined {
                        outline: ${alpha(theme.tokens.FuelColorBorderBase, 0.4)} solid 1px;
                    }
                }

                &:has(.MuiAccordion-root.Mui-disabled[data-fuel-spaced=true]) {
                    background-color: unset;

                    &.MuiPaper-outlined {
                        outline: unset;
                    }
                }

            `
        }
    },
    MuiCardContent: {
        styleOverrides: {
            root: ({ theme }) => css `
                &:last-child {
                    padding-bottom: ${theme.spacing(4)};
                }

                &[data-fuel-content-divider='none'] {
                    border: none;
                }

                &[data-fuel-content-divider='top'] {
                    border-top: 1px solid rgb(221, 221, 221);
                }

                &[data-fuel-content-divider='bottom'] {
                    border-bottom: 1px solid rgb(221, 221, 221);
                }

            `
        }
    },
    MuiCardActions: {
        styleOverrides: {
            root: ({ theme, ownerState }) => css `
                padding: 1rem;
                background-color: transparent;
                justify-content: ${ownerState['data-fuel-justify']};

                &[data-fuel-dense=true] {
                    padding: .5rem;
                }

                &[data-fuel-action-area-divider='none'] {
                    border: none;
                }

                &[data-fuel-action-area-divider='top'] {
                    border-top: 1px solid rgb(221, 221, 221);
                }

                &[data-fuel-action-area-divider='bottom'] {
                    border-bottom: 1px solid rgb(221, 221, 221);
                }

                &[data-fuel-bgcolor='gray'] {
                    background-color: ${theme.tokens.FuelColorGray50};
                }
            `
        }
    }
};
